export default function EmptyState({ image, title, subtitle, children, testid }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-14 px-6" data-testid={testid}>
      {image && (
        <div className="h-28 w-28 rounded-2xl overflow-hidden border border-sk-line mb-6 shadow-lg shadow-black/30">
          <img src={image} alt="" className="h-full w-full object-cover" />
        </div>
      )}
      <h3 className="font-bold text-lg text-sk-cream">{title}</h3>
      {subtitle && <p className="text-sk-muted text-sm mt-2 max-w-sm leading-relaxed">{subtitle}</p>}
      {children && <div className="mt-6">{children}</div>}
    </div>
  );
}
